import * as React from 'react';
import { observer } from 'mobx-react';
import { computed } from 'mobx';

/**
 * used by:
 * Notification
 */
@observer
export class NotificationPlain extends React.Component<{notification:any, user:any}> {

	@computed
	get notificationBody() {
		let content = this.props.notification.title;
		content = content.replace(/{{firstName}}/g, this.props.user.firstName);
		content = content.replace(/{{firstName}}/g, this.props.user.lastName);
		content = content.replace(/{{email}}/g, this.props.user.email);
		return {
			__html: content
		}
	}

	render(){
		return (
			<div dangerouslySetInnerHTML={this.notificationBody}></div>
		);
	}
}